<template>
  <div class="box-login">
    <div>
       <div class="title-system"><img src="static/img/logo-pb.png"/></div>
    </div>

    <div class="box-body">
      <notifications group="alert">{{ error }}</notifications>
        <div class="box-form-login">
          <form class="login" @submit.prevent="register">
            <div class="card" data-background="color" data-color="blue">
              <div class="card-header">
                <h3 class="card-title">{{ $t("48") }}</h3>
              </div>
              <div class="card-content">
                <div class="form-group">
                  <label>{{ $t("49") }}</label>
                  <input required type="text" v-model="username" class="form-control input-no-border" disabled="disabled">
                </div>

                <div class="form-group">
                  <label>{{ $t("50") }}</label>
                  <input required type="password" v-model="password_actual" class="form-control input-no-border">
                </div>
                <div class="form-group">
                  <label>{{ $t("51") }}</label>
                  <input required type="password" v-model="password_new" class="form-control input-no-border">
                </div>
                <div class="form-group">
                  <label>{{ $t("52") }}</label>
                  <input required type="password" v-model="password_repeat_new" class="form-control input-no-border">
                </div>
                <!--<p-checkbox>Me lembre da próxima vez</p-checkbox>-->
              </div>
              <div class="card-fim text-center">
                <button type="button" class="btn btn-fill btn-wd " @click="register()">OK</button>
                <!--<div class="forgot">
                  <router-link to="/register">
                    Esqueci minha senha!
                  </router-link>
                </div>-->
              </div>

              <div @click="logout" style="margin: 5px auto; text-align: center;">
                <router-link to="/admin/overview" class="btn-magnify">
                  <i class="ti-power-off"></i> {{ $t("logout") }}
                </router-link>
              </div>

            </div>
          </form>
        </div>
    </div>
    <div class="footer">
      Copyright © {{ year }} <a href="http://www.semeq.com" target="_blank">SEMEQ</a><br>
      All rights reserved
    </div>


  </div>

</template>
<script>
import Vue from 'vue'
import {AUTH_REQUEST, AUTH_LOGOUT} from '../../../../store/actions/auth'
import axios from 'axios'


export default {
  name: 'register',
  data () {
    return {
      username: null,
      password_actual: null,
      password_new: null,
      password_repeat_new: null,
      error: null,
      type: ['', 'info', 'success', 'warning', 'danger'],
      notifications: {
        topCenter: false
      },
      year: new Date().getFullYear(),
    }
  },
  methods: {
    logout: function () {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/login'))
    },
    toggleNavbar () {
      document.body.classList.toggle('nav-open')
    },
    closeMenu () {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    },
    register: function () {
      var self = this

      if( !self.password_actual || !self.password_new || !self.password_repeat_new){

         this.$notify({
          component: {
            template: `<span><b>`+ this.$t("53") +`</b></span>`
          },
          type: 'danger',
          group: 'alert',
          horizontalAlign: 'center',
          verticalAlign: 'top'
        })
      }

      //verifica quantidade de caracteres min 8 max 15:
      var password_new = self.password_new.length
      console.log('total: ', password_new)
      if(password_new < 8 || password_new > 15 ){
        this.$notify({
          component: {
            template: `<span><b>`+ this.$t("54") +`</b></span>`
          },
          type: 'info',
          group: 'alert',
          horizontalAlign: 'center',
          verticalAlign: 'top'
        })
      }
      else{
        if( self.password_actual && self.password_new && self.password_repeat_new){

          if(self.password_new != self.password_repeat_new){

            this.$notify({
              component: {
                template: `<span><b>`+ this.$t("55") +`</b></span>`
              },
              type: 'danger',
              group: 'alert',
              horizontalAlign: 'center',
              verticalAlign: 'top'
            })
          }

          else{
            //vai para endpoint que altera a senha:     
            const API = process.env.ROOT_API   
            const ENDPOINT = 'v1/users/change-password'

            axios({method: 'GET', url: API + ENDPOINT
              , params: {
                  'user':self.username
                , 'password_actual':self.password_actual
                , 'password_new':self.password_new
              } 
              , headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
            .then(resp => {
              var res = resp.data
              var hash_new = res.hash_new[0]
              var status = res.status


              if(status == 200){
                this.$notify({
                  component: {
                    template: `<span><b>`+ this.$t("56") +`</b></span>`
                  },
                  type: 'success',
                  group: 'alert',
                  horizontalAlign: 'center',
                  verticalAlign: 'top'
                })

                localStorage.setItem('hash', hash_new)

                self.$router.push('/')
              }else{
                this.$notify({
                  component: {
                    template: `<span><b>`+ this.$t("57") +`</b></span>`
                  },
                  type: 'danger',
                  group: 'alert',
                  horizontalAlign: 'center',
                  verticalAlign: 'top'
                })
              }
            })
            .catch(err => {
              this.$notify({
                component: {
                  template: `<span><b>`+ this.$t("57") +`</b></span>`
                },
                type: 'danger',
                group: 'alert',
                horizontalAlign: 'center',
                verticalAlign: 'top'
              })

              self.logout();
            })
    

          }
        }
      }
    },
  },
  beforeDestroy () {
    this.closeMenu()
  },
  mounted () {
    var self = this

    //puxa o usuário logado (username) e coloca no campo user
    var user = localStorage.getItem('username')
    self.username = user


  }
}
</script>

<style>
body{
  top:0px;
  width: 100%;
  margin: 0px auto;
  background-image: url('/static/img/background/fundo.jpg');
  background-color: #253648; 
  height: auto;
}
.box-login{
  top:0px;
  width: 100%;
  margin: 0px auto;
  height: auto;
}
.box-form-login{
  width: 315px;
  margin: 0px auto;
}
.login-page > .content, .lock-page > .content {
  padding-top: 30vh!important;
}
.vue-notifyjs .alert[data-notify="container"]{
  top:80px!important;
}
.title-system{
  text-align: center;
  height: 220px;  
}
.title-system img{
  width: 170px;
  height: auto;
  padding-top: 55px;
}
.box-body{
  width: 100%;
  height: 480px;
}
.footer{
  width: 100%;
  color: #fff;
  font-size: 12px;
  text-align: center;
}
.card-fim{
  padding: 0 15px 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Register.vue